import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ px }) => ({
  listBox: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: px(4),
  },
}));

export default useStyles;
